module.exports = __webpack_public_path__ + "static/content_3_2_do-f7258f632cb6f661ae139c41e363ca73.png";